import { createFileRoute } from "@tanstack/react-router";
import { InboxHome } from "../-components/home/inbox-home";

export const Route = createFileRoute("/_authenticated/messaging/_inbox/")({
  component: InboxHome,
});
